export const FRAMER_EASE = [0.4, 0, 0.2, 1];
export const FRAMER_BOUNCE_EASE = [0.54, 1.12, 0.38, 1.11];
export const FRAMER_TRANSITION = { ease: FRAMER_EASE, duration: 0.3 };
export const FRAMER_BOUNCE_TRANSITION = {
  ease: FRAMER_BOUNCE_EASE,
  duration: 0.3,
};
